import { HomeExamResultsPage } from './HomeExamResultsPage';
export default HomeExamResultsPage;
